<app-toasts />

<app-header />

<div class="page">
  <div class="container">

    <router-outlet />

  </div>
</div>

<lib-footer />
